export default function goToRoom(router, roomHandle, forceFullReload = false) {
  const isSafari = navigator.vendor && navigator.vendor.indexOf('Apple') > -1 &&
    navigator.userAgent &&
    navigator.userAgent.indexOf('CriOS') == -1 &&
    navigator.userAgent.indexOf('FxiOS') == -1;

  if (isSafari || forceFullReload) {
    // Since Safari is apparently leaking memory  all over the place, we are using the window.location.href method instead to change the room to force a reload
    console.log('Uusing window.location.href to change room')
    const url = router.resolve({ name: 'RoomView', params: { room_id: roomHandle } }).href
    window.location.href = url;
  } else {
    console.log('Using router.push to change room')
    router.push({ name: 'RoomView', params: { room_id: roomHandle } })
  }
}